export const videoResolutionDisplay = state =>
  state.videoResolutionDisplay



// WEBPACK FOOTER //
// ./src/redux/reducers/settingsSelector.js